export default __webpack_public_path__ + "static/media/tesla-red.b3586859.svg";